export default __webpack_public_path__ + "static/media/beneficiarioWeb.1a751e57.png";